import { useContext } from "react";

import { CheckIcon } from "../../../client/assets/icons/common/CheckIcon";
import { RightArrowIcon } from "../../../client/assets/icons/common/RightArrowIcon";
import { BaseBenefitPills } from "../../../components/BaseComponents/BaseBenefitPills";
import { BaseBenefitsList } from "../../../components/BaseComponents/BaseBenefitsList";
import { BaseCompanyLogo } from "../../../components/BaseComponents/BaseCompanyLogo";
import { BaseCoupon } from "../../../components/BaseComponents/BaseCoupon";
import { BaseFeaturedCompanyHeader } from "../../../components/BaseComponents/BaseFeaturedCompanyHeader";
import BaseGridRatingHorizontal from "../../../components/BaseComponents/BaseGridRatingHorizontal";
import BaseLinkWrapper from "../../../components/BaseComponents/BaseLinkWrapper";
import BaseProductDescription from "../../../components/BaseComponents/BaseProductDescription";
import BaseServiceFlag from "../../../components/BaseComponents/BaseServiceFlag";
import { BaseSocialProof } from "../../../components/BaseComponents/BaseSocialProof";
import { BaseVisitLink } from "../../../components/BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../../components/CompanyList/CompanyContext";
import { CouponDiscountIcon } from "../../assets/CouponDiscountIcon";
import { FeaturesVerticalContext } from "../App";
import { getStyles } from "./styles";

export const ProjectManagementCompany = () => {
	const { companyIndex, isFeaturedCompany } = useContext(CompanyContext);
	const { visitText } = useContext(FeaturesVerticalContext);
	const styles = getStyles({ isFeaturedCompany });

	return (
		<BaseLinkWrapper
			className={`tw:block tw:rounded-[12px] tw:bg-white tw:shadow-[0px_10px_16px_0px_rgba(30,41,59,0.04),0px_1px_0px_0px_rgba(30,41,59,0.02),0px_0px_8px_0px_rgba(30,41,59,0.02)] tw:transition tw:hover:shadow-[0px_8px_32px_0px_rgba(0,0,0,0.08),0px_2px_20px_0px_rgba(0,0,0,0.04)] ${
				isFeaturedCompany
					? "tw:ring-2 tw:ring-[#0B60E0]"
					: "tw:ring-1 tw:ring-[#E9ECF0]"
			}`}
		>
			<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />
			<BaseCoupon {...styles.coupon} icon={<CouponDiscountIcon />} />
			<div className="tw:relative">
				<BaseServiceFlag classNames={styles.serviceFlag} />

				<div className="tw:mx-auto tw:flex tw:max-w-[400px] tw:flex-col tw:gap-4 tw:p-4 tw:md:max-w-none tw:md:flex-row tw:md:gap-0 tw:lg:p-6">
					<div className="tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:pt-4 tw:pb-0 tw:md:py-0 tw:md:pr-1 tw:lg:w-[204px] tw:lg:pr-3 tw:xl:w-[284px]">
						<div className="tw:flex tw:w-40 tw:flex-col tw:items-center tw:justify-center">
							<BaseCompanyLogo
								classNames={styles.companyLogo}
								width={160}
								height={160}
							/>
							<BaseGridRatingHorizontal classNames={styles.rating} />
						</div>
					</div>

					<div className="tw:flex tw:grow tw:flex-col tw:md:max-w-[296px] tw:md:px-1 tw:lg:max-w-none tw:lg:px-3">
						<div className="tw:flex tw:w-full tw:flex-col">
							<BaseProductDescription className="tw:text-2xl tw:leading-8 tw:font-bold tw:tracking-[-0.24px] tw:text-balance tw:text-[#1E293B]" />
							<BaseBenefitPills />
							<BaseBenefitsList
								{...styles.benefitsList}
								icon={<CheckIcon className="tw:text-base tw:sm:mt-1" />}
							/>
						</div>
					</div>

					<div className="tw:flex tw:shrink-0 tw:md:w-[180px] tw:md:pl-1 tw:lg:pl-3 tw:xl:w-[212px]">
						<div className="tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-center">
							{companyIndex === 0 ? (
								<BaseSocialProof {...styles.socialProof} />
							) : null}
							<BaseVisitLink {...styles.visitLink} icon={<RightArrowIcon />}>
								{visitText}
							</BaseVisitLink>
						</div>
					</div>
				</div>
			</div>
		</BaseLinkWrapper>
	);
};
